"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapping = void 0;
exports.mapping = [
    [1, 1005],
    [2, 1003],
    [3, 1004],
    [4, 2001],
    [5, 2002],
    [6, 2003],
    [7, 2004],
    [8, 2005],
    [9, 3002],
    [10, 3003],
    [11, 3009],
    [12, 4003],
    [13, 3010],
    [14, 4003],
    [15, 7001],
    [16, 7002],
    [17, 7003],
    [18, 7006],
    [19, 7004],
    [20, 7005],
    [21, 1301],
    [22, 1401],
    [23, 1501],
    [24, 1601],
    [25, 1701],
    [26, 2101],
    [27, 1901],
    [28, 2301],
    [29, 2401],
    [30, 8001],
    [31, 8002],
    [32, 8003],
    [33, 8004],
    [34, 8005],
    [35, 8006],
    [36, 9001],
    // 修改
    [37, 1102],
    [38, 1103],
    [39, 1104],
    [40, 1105],
    // remove
    // [41, undefined],
    // [42, undefined],
    [43, 5004],
    [44, 5005],
    [45, 5006],
    [46, 1201],
    [47, 1203],
    [48, 1202],
    [49, 1205],
    [50, 1204],
    [51, 1206],
    [52, 2901],
    [53, 2902],
    [54, 2903],
    [55, 2904],
    [56, 2905],
    [57, 2906],
    [58, 2907],
    [59, 2601],
    [60, 2007],
];
